import React from 'react';
import RadioSelect from '../../../FormElements/RadioSelect/RadioSelect';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';

import imgSwatchBlack from '../../../../img/SwatchBlack.jpg';
import imgSwatchWhite from '../../../../img/SwatchWhite.jpg';
import imgSwatchGraphite from '../../../../img/SwatchGranite.jpg';

function Color(props) {

  const {configuration,createItem,setNextEnabled} = props;

  function handleChange(event, value) {
    setNextEnabled(true);
    createItem({id:"color",value:value});
  }

  return (
    <RadioGroup
      aria-label="Luminaire Color"
      name="color"
      onChange={handleChange}
      defaultValue={configuration["color"] ? configuration["color"] : ''}
    >
    <Grid container spacing={3}>

      {configuration.mountingOptions != "RC" ?
        <Grid item xs={4}>
          <RadioSelect value="BK" label="Black" img={imgSwatchBlack}/>
        </Grid>
        :
        <Grid item xs={4}>
          <RadioSelect disabled={true} value="BK" label="Black" img={imgSwatchBlack}/>
        </Grid>
      }
      
      <Grid item xs={4}>
        <RadioSelect value="WH" label="White" img={imgSwatchWhite}/>
      </Grid>

      {configuration.mountingOptions != "RC" ?
        <Grid item xs={4}>
          <RadioSelect value="GR" label="Graphite" img={imgSwatchGraphite}/>
        </Grid>
        :
        <Grid item xs={4}>
          <RadioSelect disabled={true} value="GR" label="Graphite" img={imgSwatchGraphite}/>
        </Grid>
      }
      
    </Grid>
    </RadioGroup>
  );
}

export default Color;
